
export const SERVER_URL = 'https://o7k7eqawme.execute-api.eu-west-1.amazonaws.com';
